<template>
    <div class="load_more" v-show="text || showImg">
        <template v-if="noDataImg">
            <img :src="imgSrc" v-if="imgSrc && (text === '无数据' || showImg)">
            <span v-else>{{text}}</span>
        </template>
        <template v-else>
            <span>{{text}}</span>
        </template>
    </div>
</template>
<script>
export default {
    props:{
        text: String,
        noDataImg: String,
        showImg: Boolean
    },
    computed:{
        imgSrc(){
            let src;
            try{
                src = require('@images/' + this.noDataImg);
            }catch{}
            return src;
        }
    }
}
</script>
<style lang="scss" scoped>
.load_more{
    text-align: center !important;
    font-size: 32px !important;
    color: #8B8C8D !important;
    padding: 10px 0;
    img{
        width: 100%;
        max-width: 500px;
        max-height: 500px;
        display: block;
        margin: 0 auto;
    }
}
</style>